import { operations } from '@luxuryescapes/contract-business/dist/server'

type ServerSocieteBusinessSettings = operations['businessSettingGetWithDefaults']['responses'][200]['content']['application/json']['result']['societe']

function mapSocieteBusinessSettings(societeBusinessSettings: ServerSocieteBusinessSettings): Record<App.LoyaltyTier, App.BusinessTraveller.BusinessSettingsSocieteTierConfig | undefined> {
  return {
    bronze: undefined,
    silver: societeBusinessSettings?.value?.silver,
    gold: societeBusinessSettings?.value?.gold,
    platinum: societeBusinessSettings?.value?.platinum,
  }
}

export default mapSocieteBusinessSettings
